import styled, { css } from 'styled-components'

import type { ThemeColor } from 'theme/theme'
import { color, pxToRem } from 'theme/utils'
import type { MakeStyledTransientProps } from 'types/utils'

type Props = MakeStyledTransientProps<{
  color?: ThemeColor
  size: number
}>

export const StyledIcon = styled.span<Props>`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;

  ${({ $size = 6 }) => css`
    &,
    svg {
      fill: currentColor;
      fill-rule: evenodd;
      height: ${pxToRem($size)};
      width: ${pxToRem($size)};
    }
  `};

  ${({ $color = 'inherit' }) =>
    $color &&
    css`
      * {
        fill: ${color($color)};
      }
    `};
`
